import styled from "styled-components";

export const VerificationContainer = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: var(--dark-opacity, rgba(7, 2, 14, 0.95));
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 9999;
`;

export const VerificationModal = styled.div`
	background-color: var(--modal-bg, linear-gradient(180deg, #1f4e38 0%, #030507 100%));
	border-radius: 8px;
	width: 90%;
	max-width: 800px;
	height: 80vh;
	max-height: 600px;
	position: relative;
	overflow: hidden;
`;

export const LoadingOverlay = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: var(--modal-overlay-bg, rgba(0, 0, 0, 0.8));
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1000;
`;

export const LoadingSpinner = styled.div`
	width: 40px;
	height: 40px;
	border: 4px solid var(--light-gray, #c1c3cc);
	border-top: 4px solid var(--main-color, #102f22);
	border-radius: 50%;
	animation: spin 1s linear infinite;

	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
`;

export const CloseButton = styled.button`
	position: absolute;
	top: 10px;
	right: 10px;
	background: none;
	border: none;
	font-size: 24px;
	cursor: pointer;
	color: var(--modal-text-color, #fbe629);
	z-index: 1001;

	&:hover {
		color: var(--main-color, #102f22);
	}
`;
